import { findWhere, result, extend } from 'underscore';
import { Scope } from '@bingads-webui-campaign-react/shell-ui-common';
import {
  breadcrumbClickHandler,
  campaignTypes,
  summaryBarScopes,
} from './index';

export const convertToBreadCrumbItems = ({
  campaignName = '',
  campaignId = null,
  adGroupName = '',
  adGroupId = null,
  adName = '',
  campaignType,
  scope,
  siteMap,
  i18n,
  summaryBarActivityLogger,
  setClarityTag = null,
}) => {
  const items = [];

  let currentScope = Scope.Account;
  const changeScopeActivity = summaryBarActivityLogger
      && summaryBarActivityLogger.changeScopeActivity.create();

  if (adName) {
    currentScope = Scope.Ad;
  } else if (adGroupId && adGroupName) {
    currentScope = Scope.AdGroup;
  } else if (campaignId && campaignName) {
    currentScope = Scope.Campaign;
  }

  const onBreadcrumbClick = (breadcrumbScope) => {
    if (breadcrumbScope === currentScope && currentScope !== Scope.Account) {
      return null;
    }

    return () => {
      if (setClarityTag) {
        setClarityTag();
      }
      breadcrumbClickHandler(breadcrumbScope, scope, siteMap);
      if (changeScopeActivity) {
        changeScopeActivity.trace({
          scope: breadcrumbScope, // Summary bar has no way to change scope to AdGroup.
          component: 'Summary Bar',
          campaignType,
        });
      }
    };
  };

  // add campaign type breadcrumb item
  const currentCampaignType = findWhere(campaignTypes, { id: campaignType });
  const campaignTypeI18nText = i18n.getString(result(currentCampaignType, 'i18nKey'));

  let currentBreadcrumb = `navigate-${summaryBarScopes.campaignType.id}`;

  items.push({
    key: currentBreadcrumb,
    text: campaignTypeI18nText,
    onClick: onBreadcrumbClick(Scope.Account),
    'aria-label': campaignTypeI18nText,
  });

  // add campaign breadcrumb item
  if (campaignId && campaignName) {
    currentBreadcrumb = `navigate-${summaryBarScopes.campaign.id}`;
    items.push({
      key: currentBreadcrumb,
      text: campaignName,
      onClick: onBreadcrumbClick(Scope.Campaign),
      'aria-label': campaignName,
    });
  }

  // add ad group breadcrumb item
  if (adGroupId && adGroupName) {
    if (!(campaignId && campaignName)) {
      // TODO: discuss with raymond, how we handle throw in new UX
      throw new Error('Ad group parent node(campaign) information is missing');
    }
    currentBreadcrumb = `navigate-${summaryBarScopes.adGroup.id}`;
    items.push({
      key: currentBreadcrumb,
      text: adGroupName,
      onClick: onBreadcrumbClick(Scope.AdGroup),
      'aria-label': adGroupName,
    });
  }

  // add ad name breadcrumb item
  if (adName) {
    if (!(adGroupId && adGroupName)) {
      // TODO: discuss with raymond, how we handle throw in new UX
      throw new Error('Ad parent node (ad group) information is missing');
    }
    currentBreadcrumb = `navigate-${summaryBarScopes.ad.id}`;
    items.push({
      key: currentBreadcrumb,
      text: adName,
      'aria-label': adName,
    });
  }

  extend(
    findWhere(items, { key: currentBreadcrumb }),
    { isCurrentItem: true }
  );

  return items;
};

